/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_N8n_Scope_Point_1Inputs */

const en_svc_n8n_scope_point_1 = /** @type {(inputs: Svc_N8n_Scope_Point_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New n8n workflows from a mapped process`)
};

const lv_svc_n8n_scope_point_1 = /** @type {(inputs: Svc_N8n_Scope_Point_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jaunas n8n darba plūsmas atbilstoši izpētītajam procesam`)
};

/**
* | output |
* | --- |
* | "New n8n workflows from a mapped process" |
*
* @param {Svc_N8n_Scope_Point_1Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_n8n_scope_point_1 = /** @type {((inputs?: Svc_N8n_Scope_Point_1Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_N8n_Scope_Point_1Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_n8n_scope_point_1(inputs)
	return en_svc_n8n_scope_point_1(inputs)
});